/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_home_portada.png'
import BarraBusqueda from "./SubComponentes/BarraBusqueda";
import BarraCorreo from "./SubComponentes/BarraCorreo";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Portada = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 62.66%, rgba(0, 0, 0, 0.63) 78.52%), url(${fondo})`,
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{color: '#fff'}}
                    >


                        <Grid container size={{xs: 12, sm: 10, md: 8}}
                              sx={{justifyContent: 'center', mt: sCell ? 18 : 24}}>
                            <BarraBusqueda/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 10, md: 8}} sx={{justifyContent: 'flex-start', mt: 6}}>
                            <Typography sx={{
                                fontSize: sCell ? 46 : 64,
                                fontWeight: 800,
                                lineHeight: 1.1,
                                textAlign: sCell ? 'center' : 'left'
                            }}>Porque tu
                                bienestar es
                                especial.</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 10, md: 8}} sx={{justifyContent: 'flex-start', mt: 6}}>
                            <Typography
                                sx={{fontSize: sCell ? 20 : 26, fontWeight: 400, textAlign: sCell ? 'center' : 'left'}}>¡Encuéntralo
                                aquí, cómpralo
                                ahora!</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-start', mt: 6, mb: sCell ? 8 : 14}}>
                            <BarraCorreo/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Portada  